import ApiRequest from './ApiRequest';

export default class Reports extends ApiRequest {
  getReportToken() {
    return this.get(`/reports/_token`);
  }
}
